import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link, navigate, graphql } from "gatsby";
import parse from "html-react-parser";
import ContentItem from "../components/content-item";
import { convertToSlug } from "../helpers/slugify";

class Grid extends Component {
  render() {
    const componentDetails = this.props.details;
    let html1, html2;
    if (typeof document !== "undefined") {
      const el = document.createElement("html");
      el.innerHTML = componentDetails.kenticoElements.n1_2_col.value;
      const all = el.querySelectorAll("body > *");
      if (all.length) {
        html1 = Array.from(all);
        html1.map((element, index) => {
          if (
            element.tagName.toLowerCase() === "h2" ||
            element.tagName.toLowerCase() === "h3"
          ) {
            element.id = convertToSlug(element.innerHTML);
          }
        });
      }
      const el2 = document.createElement("html");
      el2.innerHTML = componentDetails.kenticoElements.n2_2_col.value;
      const all2 = el2.querySelectorAll("body > *");
      if (all2.length) {
        html2 = Array.from(all2);
        html2.map((element, index) => {
          if (
            element.tagName.toLowerCase() === "h2" ||
            element.tagName.toLowerCase() === "h3"
          ) {
            element.id = convertToSlug(element.innerHTML);
          }
        });
      }
    }

    return (
      <section className="c-component c-grid">
        <div className="grid-item">
          {html1
            ? html1.map((element, index) => {
                if (
                  element.tagName.toLowerCase() !== "object" &&
                  element.tagName.toLowerCase() !== "body" &&
                  element.tagName.toLowerCase() !== "head"
                ) {
                  return parse(element.outerHTML);
                } else if ("object" === element.tagName.toLowerCase()) {
                  return (
                    <ContentItem
                      key={index}
                      codename={element.getAttribute("data-codename")}
                      chapterColor={this.props.chapterColor}
                      details={this.props.details.fields.modular_content}
                      imageArray={this.props.imageArray}
                    />
                  );
                }
              })
            : ""}
        </div>
        <div className="grid-item">
          {html2
            ? html2.map((element, index) => {
                if (
                  element.tagName.toLowerCase() !== "object" &&
                  element.tagName.toLowerCase() !== "body" &&
                  element.tagName.toLowerCase() !== "head"
                ) {
                  return parse(element.outerHTML);
                } else if ("object" === element.tagName.toLowerCase()) {
                  return (
                    <ContentItem
                      key={index}
                      codename={element.getAttribute("data-codename")}
                      chapterColor={this.props.chapterColor}
                      details={this.props.details.fields.modular_content}
                      imageArray={this.props.imageArray}
                    />
                  );
                }
              })
            : ""}
        </div>
      </section>
    );
  }
}

Grid.propTypes = {
  codename: PropTypes.string,
  details: PropTypes.object,
  chapterColor: PropTypes.string,
  imageArray: PropTypes.array,
};

export default Grid;
